import { useQueries } from '@tanstack/react-query';
import { trexTestnet } from 'pages/raas/constants/chains';
import { QUERY_KEYS } from 'shared/types/react-query';
import { BlockTag, createPublicClient, http } from 'viem';

const client = createPublicClient({
  chain: trexTestnet,
  transport: http(),
});

const BLOCK_TAGS: BlockTag[] = ['latest', 'safe', 'finalized'];

export const useGetOrbitBlocks = () => {
  const results = useQueries({
    queries: BLOCK_TAGS.map(blockTag => ({
      queryKey: [QUERY_KEYS.RAAS_ORBIT_BLOCK, blockTag],
      queryFn: () => client.getBlock({ blockTag }),
    })),
  });

  return {
    latest: results[0],
    safe: results[1],
    finalized: results[2],
  };
};
